import React, { useEffect, useState } from 'react'
import { updateArray } from '../../../utility'
import './blogAuthor.css'
import { CtiImageCompound } from '../blogArticle/componentTypes/CtiImageCompound.jsx'
import DOMPurify from 'dompurify'

const documentTitle = 'ABOUT THE THOUGHT LEADER'

export function getAuthorDetailsList(page, author) {
  const authorDetailsList = author.reduce((accumulator, authorItem) => {
    const authorDetails = page.getContent(authorItem?.$ref)?.model?.data
    if (authorDetails) {
      updateArray(accumulator, authorDetails, true)
    }
    return accumulator
  }, [])

  return authorDetailsList
}

export function BlogAuthor({ page }) {
  const document = page?.getDocument()
  const data = document?.getData()
  const { author = [] } = data ?? {}

  const [authorList, setAuthorList] = useState([])
  useEffect(() => {
    const authorDetailsList = getAuthorDetailsList(page, author)?.filter(
      (author) => !author.isTeam
    )
    const list = (authorDetailsList || []).map((author) => {
      const { image: { image = '' } = {} } = author
      const imageUrl = page.getContent(image?.$ref)?.getOriginal()?.getUrl()
      return {
        ...author,
        imageUrl,
      }
    })
    setAuthorList(list)
  }, [])

  return (
    <>
      {authorList.length === 0 ? null : (
        <BlogAuthorRendering authorList={authorList} />
      )}
    </>
  )
}

export const BlogAuthorRendering = ({ authorList = [] }) => {
  function renderAuthorCard(author) {
    const {
      displayName = '',
      title = '',
      subtitle = '',
      name = '',
      content: { value: authorDescription = '' } = {},
      image: { alt = '' } = {},
      imageUrl,
    } = author

    const contentHtml = subtitle
      ? `<p><em>${subtitle}</em></p><p>&nbsp;</p><p>${authorDescription}</p>`
      : authorDescription

    return (
      <div className="u-flex u-flexCol" key={name}>
        <div
          className="u-posRelative u-marginBottom8gu u-decoBorderLight u-decoBorderResetBottom author-card"
          id={name}
        >
          <div className="u-flex u-flexWrap">
            <CtiImageCompound
              imageUrl={imageUrl}
              alt={alt}
              classNames="u-posAbsolute u-sm-posRelative u-size4of12 u-sm-sizeFull callout-in-list-image author-image"
              imgClasses="u-sizeFull"
            />
            <div className="outerContainer u-posRelative u-sizeFull author-card-content">
              <div className="u-flex u-flexCol u-sm-paddingVert4gu u-flexAlignItemsStart full-height">
                <div className="u-flex u-sizeFull u-flexJustifyStart">
                  <div className="author-info u-flex u-flexCol u-flexAlignItemsStart u-size8of12 u-sm-sizeFull u-paddingVert8gu u-sm-paddingVert0 u-md-paddingVert4gu u-paddingRight4gu u-sm-paddingRight0">
                    <div className="u-marginBottom4gu">
                      <div className="u-bgColorBrandExtraLight u-marginBottom1gu author-title"></div>
                      <div className="u-textUppercase u-textBold u-textSecondary ">
                        {title}
                      </div>
                    </div>
                    <h3 className="u-textColorBrand u-textBold">
                      {displayName}
                    </h3>
                    <div
                      className="Content"
                      dangerouslySetInnerHTML={{
                        __html: DOMPurify.sanitize(contentHtml),
                      }}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }

  return (
    <>
      {authorList.length === 0 ? null : (
        <div className="BlogAuthor u-bgColorLight">
          <div className="u-posRelative u-sizeConstrained u-paddingTop12gu u-paddingBottom8gu ">
            <div className="BlogAuthorHeadline u-marginBottom8gu ">
              <div className="u-posRelative u-flex u-flexCol u-flexAlignItemsStart u-flexAuto u-sizeFull">
                <h2 className="u-textColorDefault u-textDefault">
                  {authorList.length > 1 ? `${documentTitle}S` : documentTitle}
                </h2>
              </div>
            </div>
            <div>
              {authorList.map((author) => {
                return renderAuthorCard(author)
              })}
            </div>
          </div>
        </div>
      )}
    </>
  )
}
